import React from 'react';
import {TileLayer} from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import { useSelector} from "react-redux";
import {MAP_OUTDOOR} from "../../../../../data/booking/constants/map_filters_type";

function getMapboxParameters()
{
    const mapBoxTokens = window.mb;
    if(mapBoxTokens) {
        let configs = [];
        for (let i = 0; i < mapBoxTokens.t.length; i++) {
            let conf = {
                token: mapBoxTokens.t[i],
                style: mapBoxTokens.s[i],
            }
            configs.push(conf)
        }
        if (configs.length > 0) {
            return configs[Math.round(Math.random() * (mapBoxTokens.t.length - 1))]
        }
    }
    return null;
}

function TileLayers() {
    const mapBoxConfig = getMapboxParameters();
    /*if(mapBoxConfig) {
        return <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url={`https://api.mapbox.com/styles/v1/${mapBoxConfig.style}/tiles/256/{z}/{x}/{y}@2x?access_token=${mapBoxConfig.token}`}

        />
    }
*/
    const mapLayer = useSelector(state => state.booking.map.mapLayer)

    return <>
            <TileLayer opacity={mapLayer == MAP_OUTDOOR ? 0 : 10}
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url={"https://data.geopf.fr/wmts?" +
                    "&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&TILEMATRIXSET=PM" +
                    "&LAYER={ignLayer}&STYLE={style}&FORMAT={format}" +
                    "&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}"}


                ignLayer='GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2'
                style='normal'
                format='image/png'

            />
            <TileLayer opacity={mapLayer != MAP_OUTDOOR ? 0 : 10}
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url={"https://{s}.tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=e6b144cfc47a48fd928dad578eb026a6"}


            />
        </>
}

export default TileLayers;